import { useAppSelector } from "app/hooks";
import { selectCurrentUser } from "features/auth/auth-slice";
import useUserRoles from "hooks/use-user-roles.hook";

import usePracticeVoiceEnabled from "./use-practice-voice-enabled.hook";

// The signed-in user has a Suno Voice seat in the practice they are working
// in: the practice has Voice turned on AND Voice Setup granted this user a
// phone (`User.voice_enabled` on /me/). A seat is granted in the user's own
// practice and /me/ keeps reporting it after a practice switch, so a switched
// session never has one — the backend's `has_voice_seat` says the same
// (ENG-2315). The phone (softphone session, dialer, ring pops) and anything
// that reads the staff directory need this.
export default function useVoiceSeat(): boolean {
  const isPracticeVoiceEnabled = usePracticeVoiceEnabled();
  const currentUser = useAppSelector(selectCurrentUser);
  const { isSwitchedSession } = useUserRoles();
  return (
    isPracticeVoiceEnabled &&
    Boolean(currentUser?.voice_enabled) &&
    !isSwitchedSession
  );
}
